"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = function useStyles(props) {
  return (0, _styles.makeStyles)(function (theme) {
    return {
      root: {
        display: 'block',
        height: props.height ? props.height : '48px',
        width: '1px',
        background: props.light ? theme.palette.background.paper : theme.palette.divider,
        margin: "0 ".concat(theme.spacing(2), "px")
      }
    };
  })();
};
var WrappedDivider = function WrappedDivider(props) {
  var classes = useStyles(props);
  var vertical = props.vertical;
  if (vertical) return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  });
  return /*#__PURE__*/_react.default.createElement(_core.Divider, props);
};
var _default = WrappedDivider;
exports.default = _default;